export default __webpack_public_path__ + "static/media/thumbnail-mobile-01.40e4f6e7.png";